<template>
  <table class="min-w-full leading-normal">
    <thead>
      <tr>
        <th
          class="pl-4 text-zt-xs border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-primary-200 font-normal tracking-wider">
          <v-checkbox data-vs-check-box="all-documents" gtm-class="zt-gtm-documents-search-selectalldocuments"
            color="primary" v-model="allSelected" @change="setDocumentSelected" />
        </th>
        <th
          class="text-zt-xs pl-2 pr-6 py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
          {{ $t("message.LicensesManager.search.searchName", { dni: $t('message.label.dni') }) }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
          {{ $t("message.documentComponent.timeDocument") }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
          {{ $t("message.documentComponent.sectorLocation") }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
          {{ $t("message.LincensesHistorySummaryComponent.labels.status") }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wider">
        </th>
      </tr>
    </thead>
    <tbody class="max-h-full">
      <tr class="group" v-for="document in content" :key="document.documentId">
        <td class="zt-gtm-documents-search-selectdocument pl-4 border-b border-gray-200">
          <v-checkbox data-vs-check-box="select-document" color="primary" :value="document.documentId"
            v-model="arrDocuments" @change="setDocumentSelected" />
        </td>
        <td class="pl-2 pr-6 border-b border-gray-200">
          <div class="text-zt-xl" :class="document.type === 'pdf' ? 'text-zt-danger' : 'text-zt-primary-200'
            ">
            <zt-icon :name="document.type === 'pdf' ? 'file-pdf' : 'file'" />
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md">
              {{ document.employee || 'Empleado inexistente' }}
            </p>
            <span class="text-zt-xs">{{ document.fiscalId }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md">{{ document.name }}</p>
            <span class="text-zt-xs">{{ document.period }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md">{{ document.sector || '-' }}</p>
            <span class="text-zt-xs">{{ document.location || '-' }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex items-center">
            <div class="h-2 w-2 rounded-full mr-2" :class="getColorByStatus(document.signStatus)" />
            <p>
              <span>{{ setUpperCase(document.signStatus.toLowerCase()) }}</span>
            </p>
          </div>
        </td>
        <td class="text-center px-4 border-b border-gray-200 group-item text-white">
          <button data-vs-button="view-document"
            class="zt-gtm-documents-search-documentview focus:outline-none text-zt-xl" v-if="document.hasPreview"
            @click="action(document)">
            <zt-icon name="eye" />
          </button>
          <zt-tooltip v-else text="Documento no disponible" position="top">
            <zt-icon class="text-zt-xl" name="eye-slash" />
          </zt-tooltip>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { forEach } from 'lodash'

const statusColors = {
  'firmado conforme': 'bg-zt-success',
  'no firmado': 'bg-zt-warning',
  'firmado disconforme': 'bg-zt-danger',
  'no requiere firma': 'bg-zt-dark-400',
  anulado: 'bg-zt-danger',
  rechazado: 'bg-zt-danger',
  'pendiente aprobacion': 'bg-zt-warning'
}

export default {
  name: 'CustomTable',
  props: {
    content: {
      type: Array
    },
    action: {
      type: Function
    }
  },
  data() {
    return {
      arrDocuments: []
    }
  },
  methods: {
    getColorByStatus(status) {
      return statusColors[status.toLowerCase()]
    },
    setDocumentSelected() {
      this.$emit('documents-selected', this.arrDocuments)
    }
  },
  computed: {
    setUpperCase() {
      return status => `${status[0].toUpperCase()}${status.slice(1)}`
    },
    allSelected: {
      set(val) {
        this.arrDocuments = []

        if (val) {
          forEach(this.content, document =>
            this.arrDocuments.push(document.documentId)
          )
        }
      },
      get() {
        return this.arrDocuments.length === this.content.length
      }
    }
  }
}
</script>
<style scoped>
.group:hover .group-item {
  color: #4f41a3;
}
</style>
